package com.example.monetix.db

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore

import dev.gitlive.firebase.auth.auth
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flowOf
import kotlinx.coroutines.flow.flow
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.launch
import kotlinx.serialization.Serializable
import kotlinx.serialization.SerialName

@Serializable
data class CloudAccount(@SerialName("id") val id: String? = null, @SerialName("name") val name: String? = null, @SerialName("logoEmoji") val logoEmoji: String? = null, @SerialName("logoUri") val logoUri: String? = null, @SerialName("isVisible") val isVisible: Boolean? = true, @SerialName("isHidden") val isHidden: Boolean? = false, @SerialName("isSavings") val isSavings: Boolean? = false, @SerialName("isArchived") val isArchived: Boolean? = false, @SerialName("isDeleted") val isDeleted: Boolean? = false, @SerialName("createdAtEpochMs") val createdAtEpochMs: Double? = 0.0, @SerialName("updatedAtEpochMs") val updatedAtEpochMs: Double? = 0.0)

@Serializable
data class CloudTransaction(@SerialName("id") val id: String? = null, @SerialName("accountId") val accountId: String? = null, @SerialName("toAccountId") val toAccountId: String? = null, @SerialName("fromAccountId") val fromAccountId: String? = null, @SerialName("amountCents") val amountCents: Double? = 0.0, @SerialName("type") val type: String? = "EXPENSE", @SerialName("dateEpochDay") val dateEpochDay: Double? = 0.0, @SerialName("categoryId") val categoryId: String? = null, @SerialName("description") val description: String? = null, @SerialName("merchantKey") val merchantKey: String? = null, @SerialName("subcategoryText") val subcategoryText: String? = null, @SerialName("logoEmoji") val logoEmoji: String? = null, @SerialName("logoUri") val logoUri: String? = null, @SerialName("isHidden") val isHidden: Boolean? = false, @SerialName("isDeleted") val isDeleted: Boolean? = false, @SerialName("reminderDays") val reminderDays: Double? = 0.0, @SerialName("createdAtEpochMs") val createdAtEpochMs: Double? = 0.0, @SerialName("updatedAtEpochMs") val updatedAtEpochMs: Double? = 0.0)

@Serializable
data class CloudCategory(@SerialName("id") val id: String? = null, @SerialName("name") val name: String? = null, @SerialName("isDeleted") val isDeleted: Boolean? = false, @SerialName("createdAtEpochMs") val createdAtEpochMs: Double? = 0.0, @SerialName("updatedAtEpochMs") val updatedAtEpochMs: Double? = 0.0)

@Serializable
data class CloudRecurring(@SerialName("id") val id: String? = null, @SerialName("name") val name: String? = null, @SerialName("type") val type: String? = "EXPENSE", @SerialName("amountCents") val amountCents: Double? = 0.0, @SerialName("accountId") val accountId: String? = null, @SerialName("toAccountId") val toAccountId: String? = null, @SerialName("categoryId") val categoryId: String? = null, @SerialName("dayOfMonth") val dayOfMonth: Double? = 1.0, @SerialName("isEnabled") val isEnabled: Boolean? = true, @SerialName("isDeleted") val isDeleted: Boolean? = false, @SerialName("cycleTarget") val cycleTarget: Double? = 0.0, @SerialName("logoEmoji") val logoEmoji: String? = null, @SerialName("logoUri") val logoUri: String? = null, @SerialName("notes") val notes: String? = null, @SerialName("autoGenerateOnReminder") val autoGenerateOnReminder: Boolean? = false, @SerialName("nextEpochDay") val nextEpochDay: Double? = 0.0, @SerialName("frequency") val frequency: String? = "Mensile", @SerialName("isPaused") val isPaused: Boolean? = false, @SerialName("startEpochDay") val startEpochDay: Double? = 0.0, @SerialName("createdAtEpochMs") val createdAtEpochMs: Double? = 0.0, @SerialName("updatedAtEpochMs") val updatedAtEpochMs: Double? = 0.0)

@Serializable
data class CloudFinancing(@SerialName("id") val id: String? = null, @SerialName("name") val name: String? = null, @SerialName("creditorName") val creditorName: String? = null, @SerialName("purpose") val purpose: String? = null, @SerialName("installmentAmountCents") val installmentAmountCents: Double? = 0.0, @SerialName("commissionCents") val commissionCents: Double? = 0.0, @SerialName("extraInstallmentCents") val extraInstallmentCents: Double? = 0.0, @SerialName("extraInstallmentMonth") val extraInstallmentMonth: Double? = 0.0, @SerialName("totalAmountCents") val totalAmountCents: Double? = 0.0, @SerialName("remainingAmountCents") val remainingAmountCents: Double? = 0.0, @SerialName("accountId") val accountId: String? = null, @SerialName("categoryId") val categoryId: String? = null, @SerialName("startEpochDay") val startEpochDay: Double? = 0.0, @SerialName("endEpochDay") val endEpochDay: Double? = 0.0, @SerialName("autoGenerateOnReminder") val autoGenerateOnReminder: Boolean? = false, @SerialName("isClosed") val isClosed: Boolean? = false, @SerialName("isDeleted") val isDeleted: Boolean? = false, @SerialName("logoEmoji") val logoEmoji: String? = null, @SerialName("logoUri") val logoUri: String? = null, @SerialName("createdAtEpochMs") val createdAtEpochMs: Double? = 0.0, @SerialName("updatedAtEpochMs") val updatedAtEpochMs: Double? = 0.0)

@Serializable
data class CloudBudget(@SerialName("categoryId") val categoryId: String? = null, @SerialName("limitCents") val limitCents: Double? = 0.0, @SerialName("isDeleted") val isDeleted: Boolean? = false, @SerialName("createdAtEpochMs") val createdAtEpochMs: Double? = 0.0, @SerialName("updatedAtEpochMs") val updatedAtEpochMs: Double? = 0.0)

@Serializable
data class CloudSavings(@SerialName("id") val id: String? = null, @SerialName("name") val name: String? = null, @SerialName("targetAmountCents") val targetAmountCents: Double? = 0.0, @SerialName("savedAmountCents") val savedAmountCents: Double? = 0.0, @SerialName("emoji") val emoji: String? = null, @SerialName("imageUri") val imageUri: String? = null, @SerialName("isCompleted") val isCompleted: Boolean? = false, @SerialName("isDeleted") val isDeleted: Boolean? = false, @SerialName("createdAtEpochMs") val createdAtEpochMs: Double? = 0.0, @SerialName("updatedAtEpochMs") val updatedAtEpochMs: Double? = 0.0)

@Serializable
data class CloudFavorite(@SerialName("id") val id: String? = null, @SerialName("description") val description: String? = null, @SerialName("amountCents") val amountCents: Double? = 0.0, @SerialName("categoryId") val categoryId: String? = null, @SerialName("logoEmoji") val logoEmoji: String? = null, @SerialName("logoUri") val logoUri: String? = null, @SerialName("isDeleted") val isDeleted: Boolean? = false, @SerialName("createdAtEpochMs") val createdAtEpochMs: Double? = 0.0, @SerialName("updatedAtEpochMs") val updatedAtEpochMs: Double? = 0.0)

@Serializable
data class CloudPiggyBank(@SerialName("id") val id: String? = null, @SerialName("name") val name: String? = null, @SerialName("accumulatedCents") val accumulatedCents: Double? = 0.0, @SerialName("emoji") val emoji: String? = null, @SerialName("colorHex") val colorHex: String? = null, @SerialName("imageUri") val imageUri: String? = null, @SerialName("isDeleted") val isDeleted: Boolean? = false, @SerialName("createdAtEpochMs") val createdAtEpochMs: Double? = 0.0, @SerialName("updatedAtEpochMs") val updatedAtEpochMs: Double? = 0.0)

@Serializable
data class CloudPrefs(
    @SerialName("activeAccountId") val activeAccountId: String? = null,
    @SerialName("navOrder") val navOrder: String? = null,
    @SerialName("hideBalances") val hideBalances: Boolean? = false,
    @SerialName("userName") val userName: String? = null,
    @SerialName("salaryDay") val salaryDay: Int? = 27,
    @SerialName("decemberSalaryDay") val decemberSalaryDay: Int? = 20,
    @SerialName("anticipateWeekends") val anticipateWeekends: Boolean? = true,
    @SerialName("deadlineHour") val deadlineHour: Int? = 8,
    @SerialName("deadlineMinute") val deadlineMinute: Int? = 30,
    @SerialName("deadlineEnabled") val deadlineEnabled: Boolean? = false,
    @SerialName("summaryHour") val summaryHour: Int? = 20,
    @SerialName("summaryMinute") val summaryMinute: Int? = 30,
    @SerialName("summaryEnabled") val summaryEnabled: Boolean? = false,
    @SerialName("autoSweepEnabled") val autoSweepEnabled: Boolean? = false,
    @SerialName("sweepDestination") val sweepDestination: String? = "SOGNI",
    @SerialName("themeMode") val themeMode: String? = null,
    @SerialName("appLockEnabled") val appLockEnabled: Boolean? = null,
    @SerialName("safetyBufferCents") val safetyBufferCents: Long? = null,
    @SerialName("bankAdjustmentCents") val bankAdjustmentCents: Double? = 0.0,

    @SerialName("vaultPin") val vaultPin: String? = null,
    @SerialName("emergencyTargetCents") val emergencyTargetCents: Long? = null,
    @SerialName("userIban") val userIban: String? = null,
    @SerialName("appBackgroundUri") val appBackgroundUri: String? = null
)

// Helper methods deleted because kotlinx.serialization natively handles this now

class FirestoreHelper {
    companion object {
        var globalSessionUid: String? = null

        // 🚀 SPOSTATO NEL COMPANION OBJECT (LAZY).
        // Si avvia UNA sola volta per l'intera app, eliminando i crash del Web!
        val db by lazy { Firebase.firestore }
    }
    var sessionUid: String? get() = globalSessionUid; set(value) { globalSessionUid = value }
    private fun getUidSafe(): String? = globalSessionUid ?: Firebase.auth.currentUser?.uid

    private fun Boolean?.safeBool(): Boolean { val str = this.toString(); return str == "true" || str == "1" }
    private fun Any?.safeDouble(): Double { if (this == null) return 0.0; return this.toString().toDoubleOrNull() ?: 0.0 }

    suspend fun distruggiTuttoIlCloud() {
        val uid = getUidSafe() ?: return
        val collezioni = listOf("conti", "movimenti", "categorie", "ricorrenti", "debiti", "budgets", "risparmi", "preferiti", "salvadanai")
        coroutineScope { collezioni.forEach { coll -> launch { try { val snapshot = db.collection("users").document(uid).collection(coll).get(); snapshot.documents.forEach { doc -> db.collection("users").document(uid).collection(coll).document(doc.id).delete() } } catch (e: Throwable) {} } } }
        try { db.clearPersistence() } catch(e: Throwable) {}
    }

    suspend fun salva(collezione: String, id: String, data: AccountEntity) { val uid = getUidSafe() ?: return; try { db.collection("users").document(uid).collection(collezione).document(id).set(CloudAccount(data.id, data.name, data.logoEmoji, data.logoUri, data.isVisible.safeBool(), data.isHidden.safeBool(), data.isSavings.safeBool(), data.isArchived.safeBool(), data.isDeleted.safeBool(), data.createdAtEpochMs.safeDouble(), data.updatedAtEpochMs.safeDouble())) } catch (e: Throwable) {} }
    suspend fun salva(collezione: String, id: String, data: TransactionEntity) { val uid = getUidSafe() ?: return; try { db.collection("users").document(uid).collection(collezione).document(id).set(CloudTransaction(data.id, data.accountId, data.toAccountId, data.fromAccountId, data.amountCents.safeDouble(), data.type ?: "EXPENSE", data.dateEpochDay.safeDouble(), data.categoryId, data.description, data.merchantKey, data.subcategoryText, data.logoEmoji, data.logoUri, data.isHidden.safeBool(), data.isDeleted.safeBool(), data.reminderDays.safeDouble(), data.createdAtEpochMs.safeDouble(), data.updatedAtEpochMs.safeDouble())) } catch (e: Throwable) {} }
    suspend fun salva(collezione: String, id: String, data: CategoryEntity) { val uid = getUidSafe() ?: return; try { db.collection("users").document(uid).collection(collezione).document(id).set(CloudCategory(data.id, data.name, data.isDeleted.safeBool(), data.createdAtEpochMs.safeDouble(), data.updatedAtEpochMs.safeDouble())) } catch (e: Throwable) {} }
    suspend fun salva(collezione: String, id: String, data: RecurringExpenseEntity) { val uid = getUidSafe() ?: return; try { db.collection("users").document(uid).collection(collezione).document(id).set(CloudRecurring(data.id, data.name, data.type, data.amountCents.safeDouble(), data.accountId, data.toAccountId, data.categoryId, data.dayOfMonth.safeDouble(), data.isEnabled.safeBool(), data.isDeleted.safeBool(), data.cycleTarget.safeDouble(), data.logoEmoji, data.logoUri, data.notes, data.autoGenerateOnReminder.safeBool(), data.nextEpochDay.safeDouble(), data.frequency, data.isPaused.safeBool(), data.startEpochDay.safeDouble(), data.createdAtEpochMs.safeDouble(), data.updatedAtEpochMs.safeDouble())) } catch (e: Throwable) {} }
    suspend fun salva(collezione: String, id: String, data: FinancingEntity) { val uid = getUidSafe() ?: return; try { db.collection("users").document(uid).collection(collezione).document(id).set(CloudFinancing(data.id, data.name, data.creditorName, data.purpose, data.installmentAmountCents.safeDouble(), data.commissionCents.safeDouble(), data.extraInstallmentCents.safeDouble(), data.extraInstallmentMonth.safeDouble(), data.totalAmountCents.safeDouble(), data.remainingAmountCents.safeDouble(), data.accountId, data.categoryId, data.startEpochDay.safeDouble(), data.endEpochDay.safeDouble(), data.autoGenerateOnReminder.safeBool(), data.isClosed.safeBool(), data.isDeleted.safeBool(), data.logoEmoji, data.logoUri, data.createdAtEpochMs.safeDouble(), data.updatedAtEpochMs.safeDouble())) } catch (e: Throwable) {} }
    suspend fun salva(collezione: String, id: String, data: BudgetEntity) { val uid = getUidSafe() ?: return; try { db.collection("users").document(uid).collection(collezione).document(id).set(CloudBudget(data.categoryId, data.limitCents.safeDouble(), data.isDeleted.safeBool(), data.createdAtEpochMs.safeDouble(), data.updatedAtEpochMs.safeDouble())) } catch (e: Throwable) {} }
    suspend fun salva(collezione: String, id: String, data: SavingsGoalEntity) { val uid = getUidSafe() ?: return; try { db.collection("users").document(uid).collection(collezione).document(id).set(CloudSavings(data.id, data.name, data.targetAmountCents.safeDouble(), data.savedAmountCents.safeDouble(), data.emoji, data.imageUri, data.isCompleted.safeBool(), data.isDeleted.safeBool(), data.createdAtEpochMs.safeDouble(), data.updatedAtEpochMs.safeDouble())) } catch (e: Throwable) {} }
    suspend fun salva(collezione: String, id: String, data: FavoriteTemplateEntity) { val uid = getUidSafe() ?: return; try { db.collection("users").document(uid).collection(collezione).document(id).set(CloudFavorite(data.id, data.description, data.amountCents.safeDouble(), data.categoryId, data.logoEmoji, data.logoUri, data.isDeleted.safeBool(), data.createdAtEpochMs.safeDouble(), data.updatedAtEpochMs.safeDouble())) } catch (e: Throwable) {} }
    suspend fun salva(collezione: String, id: String, data: PiggyBankEntity) { val uid = getUidSafe() ?: return; try { db.collection("users").document(uid).collection(collezione).document(id).set(CloudPiggyBank(data.id, data.name, data.accumulatedCents.safeDouble(), data.emoji, data.colorHex, data.imageUri, data.isDeleted.safeBool(), data.createdAtEpochMs.safeDouble(), data.updatedAtEpochMs.safeDouble())) } catch (e: Throwable) {} }

    suspend fun elimina(collezione: String, id: String) { val uid = getUidSafe() ?: return; try { db.collection("users").document(uid).collection(collezione).document(id).delete() } catch (e: Throwable) {} }

    // 🚀 Aggiunto merge = true per salvataggi più sicuri
    suspend fun salvaAccountAttivo(accountId: String?) { val uid = getUidSafe() ?: return; try { db.collection("users").document(uid).collection("preferenze").document("impostazioni").set(mapOf("activeAccountId" to accountId), merge = true) } catch (e: Throwable) { } }

    suspend fun salvaPreferenze(prefs: CloudPrefs) {
        val uid = getUidSafe() ?: return
        try {
            // Usa il merge per evitare che la UI web resetti i campi per errore
            db.collection("users").document(uid).collection("preferenze").document("impostazioni").set(prefs, merge = true)
        } catch (e: Throwable) { }
    }

    // 🚀 IL NUOVO METODO DEDICATO E A PROVA DI BOMBA (Bypassa i bug di serializzazione JS)
    suspend fun salvaBankAdjustment(cents: Long) {
        val uid = getUidSafe() ?: return
        val docRef = db.collection("users").document(uid).collection("preferenze").document("impostazioni")
        try {
            docRef.set(mapOf("bankAdjustmentCents" to cents.toDouble()), merge = true)
            println("🔥 [WEB-SAFE] Bank adjustment aggiornato su Firebase in modo isolato!")
        } catch (e: Throwable) {
            println("🔥 [WEB-SAFE] Errore critico bank adjustment: ${e.message}")
        }
    }

    suspend fun salvaPinVault(pin: String) {
        val uid = getUidSafe()
        if (uid == null) {
            println("🕵️ SPIA FIREBASE (Scrittura): FALLITA! Utente non loggato (UID nullo).")
            return
        }
        val docRef = db.collection("users").document(uid).collection("preferenze").document("impostazioni")
        try {
            println("🕵️ SPIA FIREBASE (Scrittura): Tento di salvare il PIN '$pin' per l'utente $uid...")
            docRef.set(mapOf("vaultPin" to pin), merge = true)
            println("🕵️ SPIA FIREBASE (Scrittura): SUCCESSO! PIN salvato nel cloud.")
        } catch (e: Throwable) {
            println("🕵️ SPIA FIREBASE (Scrittura): ERRORE GRAVE -> ${e.message}")
        }
    }

    // 🚀 2. FUNZIONE PER SALVARE LO SCUDO
    suspend fun salvaTargetScudo(targetCents: Long) {
        val uid = getUidSafe() ?: return
        val docRef = db.collection("users").document(uid).collection("preferenze").document("impostazioni")
        try {
            docRef.set(mapOf("emergencyTargetCents" to targetCents), merge = true)
            println("🔥 [CLOUD] Target Scudo aggiornato su Firebase!")
        } catch (e: Throwable) {
            println("🔥 [CLOUD] Errore salvataggio Scudo: ${e.message}")
        }
    }

    suspend fun salvaAccountIban(accountId: String, iban: String) {
        val uid = getUidSafe() ?: return
        val docRef = db.collection("users").document(uid).collection("preferenze").document("ibans")
        try {
            docRef.set(mapOf(accountId to iban), merge = true)
            println("🔥 [CLOUD] IBAN per conto $accountId aggiornato su Firebase!")
        } catch (e: Throwable) {
            println("🔥 [CLOUD] Errore salvataggio IBAN conto: ${e.message}")
        }
    }

    suspend fun salvaAccountBankDetails(accountId: String, details: Map<String, String>) {
        val uid = getUidSafe() ?: return
        val docRef = db.collection("users").document(uid).collection("preferenze").document("account_bank_details")
        try {
            docRef.set(mapOf(accountId to details), merge = true)
            println("🔥 [CLOUD] Coordinate bancarie complete per conto $accountId aggiornate su Firebase!")
        } catch (e: Throwable) {
            println("🔥 [CLOUD] Errore salvataggio coordinate conto: ${e.message}")
        }
    }

    suspend fun salvaAppBackgroundUri(uri: String?) {
        val uid = getUidSafe() ?: return
        val docRef = db.collection("users").document(uid).collection("preferenze").document("background")
        try {
            if (uri.isNullOrBlank()) {
                docRef.set(mapOf("uri" to ""), merge = false)
                println("🔥 [CLOUD] AppBackgroundUri rimosso dal cloud!")
            } else {
                docRef.set(mapOf("uri" to uri), merge = false)
                println("🔥 [CLOUD] AppBackgroundUri salvato con successo nel cloud!")
            }
        } catch (e: Throwable) {
            println("🔥 [CLOUD] Errore salvataggio AppBackgroundUri: ${e.message}")
        }
    }

    @OptIn(ExperimentalCoroutinesApi::class)
    fun scaricaAppBackgroundUri(): Flow<String?> {
        return getUidFlow().flatMapLatest { uid ->
            db.collection("users").document(uid).collection("preferenze").document("background").snapshots.map { doc ->
                if (doc.exists) {
                    try {
                        doc.get<String?>("uri")?.takeIf { it.isNotBlank() }
                    } catch (e: Throwable) { null }
                } else null
            }.catch { emit(null) }
        }
    }

    fun getUidFlow(): Flow<String> {
        return flow {
            var uid = getUidSafe()
            var retries = 0
            while (uid == null && retries < 150) {
                kotlinx.coroutines.delay(100)
                uid = getUidSafe()
                retries++
            }
            if (uid != null) {
                emit(uid)
            }
        }.distinctUntilChanged()
    }

    @OptIn(ExperimentalCoroutinesApi::class)
    fun scaricaAccountBankDetails(): Flow<Map<String, Map<String, String>>> {
        return getUidFlow().flatMapLatest { uid ->
            db.collection("users").document(uid).collection("preferenze").document("account_bank_details").snapshots.map { snapshot ->
                if (snapshot.exists) {
                    try {
                        snapshot.data<Map<String, Map<String, String>>>()
                    } catch (e: Throwable) {
                        emptyMap()
                    }
                } else {
                    emptyMap()
                }
            }.catch { emit(emptyMap()) }
        }
    }

    @OptIn(ExperimentalCoroutinesApi::class)
    fun scaricaAccountIbans(): Flow<Map<String, String>> {
        return getUidFlow().flatMapLatest { uid ->
            db.collection("users").document(uid).collection("preferenze").document("ibans").snapshots.map { snapshot ->
                if (snapshot.exists) {
                    try {
                        snapshot.data<Map<String, String>>()
                    } catch (e: Throwable) {
                        emptyMap()
                    }
                } else {
                    emptyMap()
                }
            }.catch { emit(emptyMap()) }
        }
    }

    suspend fun salvaOrdineNavigazione(nuovoOrdine: String) {
        val uid = getUidSafe() ?: return
        val docRef = db.collection("users").document(uid).collection("preferenze").document("impostazioni")
        try {
            docRef.set(mapOf("navOrder" to nuovoOrdine), merge = true)
            println("🔥 [NAV-DEBUG] Ordine aggiornato su Firebase (Web-Safe)!")
        } catch (e: Throwable) {
            println("🔥 [NAV-DEBUG] Errore critico nel salvataggio ordine: ${e.message}")
        }
    }

    @OptIn(ExperimentalCoroutinesApi::class)
    fun getPreferenze(): Flow<CloudPrefs?> {
        return getUidFlow().flatMapLatest { uid ->
            db.collection("users").document(uid).collection("preferenze").document("impostazioni").snapshots.map { doc ->
                if (doc.exists) {
                    try {
                        doc.data<CloudPrefs>()
                    } catch (e: Throwable) { CloudPrefs(null) }
                } else CloudPrefs(null)
            }
        }
    }

    @OptIn(ExperimentalCoroutinesApi::class)
    fun scaricaConti(): Flow<List<AccountEntity>> {
        return getUidFlow().flatMapLatest { uid ->
            db.collection("users").document(uid).collection("conti").snapshots.map { snapshot ->
                snapshot.documents.mapNotNull { doc ->
                    try {
                        val cloud = doc.data<CloudAccount>()
                        AccountEntity(
                            id = cloud.id ?: doc.id,
                            name = cloud.name ?: "Conto",
                            logoEmoji = cloud.logoEmoji ?: "",
                            logoUri = cloud.logoUri ?: "",
                            isVisible = cloud.isVisible ?: true,
                            isHidden = cloud.isHidden ?: false,
                            isSavings = cloud.isSavings ?: false,
                            isArchived = cloud.isArchived ?: false,
                            isDeleted = cloud.isDeleted ?: false,
                            createdAtEpochMs = (cloud.createdAtEpochMs ?: 0.0).toLong(),
                            updatedAtEpochMs = (cloud.updatedAtEpochMs ?: 0.0).toLong()
                        )
                    } catch (e: Throwable) { null }
                }.filter { !it.isDeleted }
            }
        }
    }

    @OptIn(ExperimentalCoroutinesApi::class)
    fun scaricaMovimenti(): Flow<List<TransactionEntity>> {
        return getUidFlow().flatMapLatest { uid ->
            db.collection("users").document(uid).collection("movimenti").snapshots.map { snapshot ->
                snapshot.documents.mapNotNull { doc ->
                    try {
                        val cloud = doc.data<CloudTransaction>()
                        TransactionEntity(
                            id = cloud.id ?: doc.id,
                            accountId = cloud.accountId,
                            toAccountId = cloud.toAccountId,
                            fromAccountId = cloud.fromAccountId,
                            amountCents = (cloud.amountCents ?: 0.0).toLong(),
                            type = cloud.type ?: "EXPENSE",
                            dateEpochDay = (cloud.dateEpochDay ?: 0.0).toLong(),
                            categoryId = cloud.categoryId ?: "",
                            description = cloud.description ?: "",
                            merchantKey = cloud.merchantKey ?: "",
                            subcategoryText = cloud.subcategoryText ?: "",
                            logoEmoji = cloud.logoEmoji ?: "",
                            logoUri = cloud.logoUri ?: "",
                            isHidden = cloud.isHidden ?: false,
                            isDeleted = cloud.isDeleted ?: false,
                            reminderDays = (cloud.reminderDays ?: 0.0).toLong(),
                            createdAtEpochMs = (cloud.createdAtEpochMs ?: 0.0).toLong(),
                            updatedAtEpochMs = (cloud.updatedAtEpochMs ?: 0.0).toLong()
                        )
                    } catch (e: Throwable) { null }
                }.filter { !it.isDeleted }
            }
        }
    }

    @OptIn(ExperimentalCoroutinesApi::class)
    fun scaricaCategorie(): Flow<List<CategoryEntity>> {
        return getUidFlow().flatMapLatest { uid ->
            db.collection("users").document(uid).collection("categorie").snapshots.map { snapshot ->
                snapshot.documents.mapNotNull { doc ->
                    try {
                        val cloud = doc.data<CloudCategory>()
                        CategoryEntity(
                            id = cloud.id ?: doc.id,
                            name = cloud.name ?: "Categoria",
                            isDeleted = cloud.isDeleted ?: false,
                            createdAtEpochMs = (cloud.createdAtEpochMs ?: 0.0).toLong(),
                            updatedAtEpochMs = (cloud.updatedAtEpochMs ?: 0.0).toLong()
                        )
                    } catch (e: Throwable) { null }
                }.filter { !it.isDeleted }
            }
        }
    }

    @OptIn(ExperimentalCoroutinesApi::class)
    fun scaricaRicorrenti(): Flow<List<RecurringExpenseEntity>> {
        return getUidFlow().flatMapLatest { uid ->
            db.collection("users").document(uid).collection("ricorrenti").snapshots.map { snapshot ->
                snapshot.documents.mapNotNull { doc ->
                    try {
                        val cloud = doc.data<CloudRecurring>()
                        RecurringExpenseEntity(
                            id = cloud.id ?: doc.id,
                            name = cloud.name ?: "Spesa",
                            type = cloud.type ?: "EXPENSE",
                            amountCents = (cloud.amountCents ?: 0.0).toLong(),
                            accountId = cloud.accountId ?: "",
                            toAccountId = cloud.toAccountId,
                            categoryId = cloud.categoryId ?: "",
                            dayOfMonth = (cloud.dayOfMonth ?: 1.0).toLong(),
                            isEnabled = cloud.isEnabled ?: true,
                            isDeleted = cloud.isDeleted ?: false,
                            cycleTarget = (cloud.cycleTarget ?: 0.0).toLong(),
                            logoEmoji = cloud.logoEmoji,
                            logoUri = cloud.logoUri,
                            notes = cloud.notes,
                            autoGenerateOnReminder = cloud.autoGenerateOnReminder ?: false,
                            nextEpochDay = (cloud.nextEpochDay ?: 0.0).toLong(),
                            frequency = cloud.frequency ?: "Mensile",
                            isPaused = cloud.isPaused ?: false,
                            startEpochDay = (cloud.startEpochDay ?: 0.0).toLong(),
                            createdAtEpochMs = (cloud.createdAtEpochMs ?: 0.0).toLong(),
                            updatedAtEpochMs = (cloud.updatedAtEpochMs ?: 0.0).toLong()
                        )
                    } catch (e: Throwable) { null }
                }.filter { !it.isDeleted }
            }
        }
    }

    @OptIn(ExperimentalCoroutinesApi::class)
    fun scaricaDebiti(): Flow<List<FinancingEntity>> {
        return getUidFlow().flatMapLatest { uid ->
            db.collection("users").document(uid).collection("debiti").snapshots.map { snapshot ->
                snapshot.documents.mapNotNull { doc ->
                    try {
                        val cloud = doc.data<CloudFinancing>()
                        FinancingEntity(
                            id = cloud.id ?: doc.id,
                            name = cloud.name ?: "",
                            creditorName = cloud.creditorName ?: "",
                            purpose = cloud.purpose ?: "",
                            installmentAmountCents = (cloud.installmentAmountCents ?: 0.0).toLong(),
                            commissionCents = (cloud.commissionCents ?: 0.0).toLong(),
                            extraInstallmentCents = (cloud.extraInstallmentCents ?: 0.0).toLong(),
                            extraInstallmentMonth = (cloud.extraInstallmentMonth ?: 0.0).toLong(),
                            totalAmountCents = (cloud.totalAmountCents ?: 0.0).toLong(),
                            remainingAmountCents = (cloud.remainingAmountCents ?: 0.0).toLong(),
                            accountId = cloud.accountId ?: "",
                            categoryId = cloud.categoryId ?: "",
                            startEpochDay = (cloud.startEpochDay ?: 0.0).toLong(),
                            endEpochDay = (cloud.endEpochDay ?: 0.0).toLong(),
                            autoGenerateOnReminder = cloud.autoGenerateOnReminder ?: false,
                            isClosed = cloud.isClosed ?: false,
                            isDeleted = cloud.isDeleted ?: false,
                            logoEmoji = cloud.logoEmoji,
                            logoUri = cloud.logoUri,
                            createdAtEpochMs = (cloud.createdAtEpochMs ?: 0.0).toLong(),
                            updatedAtEpochMs = (cloud.updatedAtEpochMs ?: 0.0).toLong()
                        )
                    } catch (e: Throwable) { null }
                }.filter { !it.isDeleted }
            }
        }
    }

    @OptIn(ExperimentalCoroutinesApi::class)
    fun scaricaBudgets(): Flow<List<BudgetEntity>> {
        return getUidFlow().flatMapLatest { uid ->
            db.collection("users").document(uid).collection("budgets").snapshots.map { snapshot ->
                snapshot.documents.mapNotNull { doc ->
                    try {
                        val cloud = doc.data<CloudBudget>()
                        BudgetEntity(
                            categoryId = cloud.categoryId ?: doc.id,
                            limitCents = (cloud.limitCents ?: 0.0).toLong(),
                            isDeleted = cloud.isDeleted ?: false,
                            createdAtEpochMs = (cloud.createdAtEpochMs ?: 0.0).toLong(),
                            updatedAtEpochMs = (cloud.updatedAtEpochMs ?: 0.0).toLong()
                        )
                    } catch (e: Throwable) { null }
                }.filter { !it.isDeleted }
            }
        }
    }

    @OptIn(ExperimentalCoroutinesApi::class)
    fun scaricaRisparmi(): Flow<List<SavingsGoalEntity>> {
        return getUidFlow().flatMapLatest { uid ->
            db.collection("users").document(uid).collection("risparmi").snapshots.map { snapshot ->
                snapshot.documents.mapNotNull { doc ->
                    try {
                        val cloud = doc.data<CloudSavings>()
                        SavingsGoalEntity(
                            id = cloud.id ?: doc.id,
                            name = cloud.name ?: "Sogno",
                            targetAmountCents = (cloud.targetAmountCents ?: 0.0).toLong(),
                            savedAmountCents = (cloud.savedAmountCents ?: 0.0).toLong(),
                            emoji = cloud.emoji ?: "",
                            imageUri = cloud.imageUri ?: "",
                            isCompleted = cloud.isCompleted ?: false,
                            isDeleted = cloud.isDeleted ?: false,
                            createdAtEpochMs = (cloud.createdAtEpochMs ?: 0.0).toLong(),
                            updatedAtEpochMs = (cloud.updatedAtEpochMs ?: 0.0).toLong()
                        )
                    } catch (e: Throwable) { null }
                }.filter { !it.isDeleted }
            }
        }
    }

    @OptIn(ExperimentalCoroutinesApi::class)
    fun scaricaPreferiti(): Flow<List<FavoriteTemplateEntity>> {
        return getUidFlow().flatMapLatest { uid ->
            db.collection("users").document(uid).collection("preferiti").snapshots.map { snapshot ->
                snapshot.documents.mapNotNull { doc ->
                    try {
                        val cloud = doc.data<CloudFavorite>()
                        FavoriteTemplateEntity(
                            id = cloud.id ?: doc.id,
                            description = cloud.description ?: "",
                            amountCents = (cloud.amountCents ?: 0.0).toLong(),
                            categoryId = cloud.categoryId ?: "",
                            logoEmoji = cloud.logoEmoji,
                            logoUri = cloud.logoUri,
                            isDeleted = cloud.isDeleted ?: false,
                            createdAtEpochMs = (cloud.createdAtEpochMs ?: 0.0).toLong(),
                            updatedAtEpochMs = (cloud.updatedAtEpochMs ?: 0.0).toLong()
                        )
                    } catch (e: Throwable) { null }
                }.filter { !it.isDeleted }
            }
        }
    }

    @OptIn(ExperimentalCoroutinesApi::class)
    fun scaricaSalvadanai(): Flow<List<PiggyBankEntity>> {
        return getUidFlow().flatMapLatest { uid ->
            db.collection("users").document(uid).collection("salvadanai").snapshots.map { snapshot ->
                snapshot.documents.mapNotNull { doc ->
                    try {
                        val cloud = doc.data<CloudPiggyBank>()
                        PiggyBankEntity(
                            id = cloud.id ?: doc.id,
                            name = cloud.name ?: "Salvadanaio",
                            accumulatedCents = (cloud.accumulatedCents ?: 0.0).toLong(),
                            emoji = cloud.emoji ?: "🪙",
                            colorHex = cloud.colorHex ?: "#2A9D8F",
                            imageUri = cloud.imageUri ?: "",
                            isDeleted = cloud.isDeleted ?: false,
                            createdAtEpochMs = (cloud.createdAtEpochMs ?: 0.0).toLong(),
                            updatedAtEpochMs = (cloud.updatedAtEpochMs ?: 0.0).toLong()
                        )
                    } catch (e: Throwable) { null }
                }.filter { !it.isDeleted }
            }
        }
    }
}